import {Injectable} from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import {Observable} from 'rxjs';
import {ConnectedUserService} from '../../../context/connected-user.service';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class IsSimulationStartedGuard  {
    constructor(
        private readonly router: Router,
        private readonly connectedUserService: ConnectedUserService
    ) {
    }

    canActivate(): Observable<boolean | UrlTree> {
        return this.connectedUserService.isSimulationActivated().pipe(
            map(simulationIsActivated => {
                if (simulationIsActivated) {
                    return true;
                } else {
                    return this.router.parseUrl('/session/decisions/simulation/');
                }
            })
        );
    }
}
